import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import './language/config';

import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';

import './global.scss';
import SeoComponent from "./components/SeoComponent/SeoComponent";
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: "https://c490bca6bc88468b248ae4c6dd0b1a98@apm.ryze-cloud.de/15",
  integrations: [],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <SeoComponent />
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
